import { initializeApp } from "firebase/app";
import { demarrerAppCheckEnFond } from "./appCheck";
import {
  indexedDBLocalPersistence,
  browserLocalPersistence,
  browserSessionPersistence,
  connectAuthEmulator,
  initializeAuth,
} from "firebase/auth";

import {
  connectFirestoreEmulator,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";
import { firebaseConfig } from "./config";

const app = initializeApp(firebaseConfig);

// APP CHECK (C1, 25/09/2026) : chaque requête Firestore porte un jeton qui
// prouve qu'elle vient de NOTRE app servie depuis nos domaines (reCAPTCHA
// Enterprise, score invisible, aucune case à cocher pour l'enfant). Sans lui,
// n'importe quel script muni de la clé API publique parle à la base.
// Activé seulement si une clé de site est fournie au build : sans clé (dev
// local, émulateurs, prod tant que sa clé n'existe pas), rien ne change.
// Côté projet, Firestore reste en SURVEILLANCE (« unenforced ») : les requêtes
// sans jeton passent encore, on mesure d'abord.
// Démarrage en ARRIÈRE-PLAN (26/09) : l'app n'attend plus App Check pour se
// monter, et l'écran de scan n'attend jamais reCAPTCHA (voir appCheck.js).
const appCheckSiteKey = import.meta.env.VITE_APPCHECK_SITE_KEY;
if (appCheckSiteKey && import.meta.env.VITE_USE_EMULATORS !== "true") {
  demarrerAppCheckEnFond(app, appCheckSiteKey);
}

const auth = initializeAuth(app, {
  persistence: [indexedDBLocalPersistence, browserLocalPersistence, browserSessionPersistence],
});
const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
});
const storage = getStorage(app);
let analytics = null;

if (import.meta.env.VITE_USE_EMULATORS === "true") {
  connectAuthEmulator(auth, "http://localhost:9099");
  connectFirestoreEmulator(db, "localhost", "3000");
  connectStorageEmulator(storage, "localhost", "9199");
} else {
  analytics = getAnalytics(app);
}

export { auth, db, storage, analytics };
